<template>
    <Button label="Добавить инвойс" icon="pi pi-plus" class="flex" @click="showDialog" severity="info" size="small"/>

    <Dialog class="flex flex-column border-none max-w-30rem p-0 
        m-0 xl:m-3 lg:m-2 md:m-1" modal
        v-model:visible="dialog"
        style="max-height:100%!important"
        :position="screenSize=='xs' ? 'bottom' : 'right'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: '900px', height: '100%!important' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <div class="flex flex-column w-full mb-3">
                <span class="flex text-lg font-medium">Добавить инвойс</span>
            </div>
        </template>

        <div class="flex flex-column w-full h-full gap-3">
            <div class="flex flex-column w-full gap-2">
                <span class="flex">Выберите программу <span class="text-red-500">*</span>: </span>
                <Select v-model="program" class="w-full mb-3" :options="paymentSystems" placeholder="Выберите программу" optionLabel="label" optionValue="code" :loading="loading"/>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Выберите клиента <span class="text-red-500">*</span>: </span>
                <Select v-model="client" class="w-full mb-3" :options="clients" placeholder="Выберите клиента" optionLabel="fullname"
                    filter showClear :loading="loading" :disabled="loading || !program">
                    <template #value="slotProps">
                        <div v-if="slotProps.value" class="flex items-center">
                            <div>{{ slotProps.value.first_name }} {{ slotProps.value.last_name }}</div>
                        </div>
                        <span v-else>
                            {{ slotProps.placeholder }}
                        </span>
                    </template>
                    <template #option="slotProps">
                        <div class="flex flex-row gap-1 justify-content-start align-items-center">
                            <span class="flex">{{ slotProps.option.first_name }} {{ slotProps.option.last_name }}</span>
                            <span class="flex">{{ slotProps.option.email }}</span>
                            <Tag v-if="slotProps.option.kyc && slotProps.option.kyc.type" :severity="slotProps.option.kyc.type" :value="slotProps.option.kyc.type" class="text-xs" />
                            <Tag :value="getStatusTitle(slotProps.option)" class="text-xs" :severity="getSeverity(slotProps.option)" />
                        </div>
                    </template>
                </Select>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Сумма в руб <span class="text-red-500">*</span>: </span>
                <InputNumber v-model="order.amount" class="flex" :minFractionDigits="0" :maxFractionDigits="2" :min="currentLimits.min" :max="currentLimits.max" placeholder="100"
                    :currency="order.currency_code" mode="currency"/>
                <small v-if="program" class="text-500">Лимиты: от {{ currentLimits.min.toLocaleString('ru-RU') }} ₽ до {{ currentLimits.max.toLocaleString('ru-RU') }} ₽</small>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Описание <span class="text-red-500">*</span>: </span>
                <Textarea v-model="order.description" />
            </div>
        </div>

        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Добавить" @click='AddOrder()' :loading="loading" class="flex" :disabled="loading || !checking" severity="info"/>
                <Button label="Закрыть" icon="pi pi-times" @click="dialog = false" outlined class="flex" autofocus severity="secondary" :disabled="loading"/>
            </div>
        </template>

    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'

export default {
    props: {
        
    },
    data() {
        return {
            loading: false,
            dialog: false,
            client: {},
            order: {
                client_id: null,
                amount: null,
                currency_code: 'RUB',
                payment_system_code: null,
                description: null
            },
            minAmount: 10,
            maxAmount: 999999999,

            clients: [],
            allClients: [],
            program: null,
        }
    },
    components: {

    },
    computed: {
        screenSize() { return this.$store.getters.StateScreenSize },
        paymentSystems() { 
            const userPaymentSystems = this.$store.getters.StatePaymentSystems
            if(!userPaymentSystems || userPaymentSystems.length === 0) return []
            let formated = []
            for(const ps of userPaymentSystems){
                formated.push({ 
                    code: ps, 
                    kyc_required: ps.kyc_required, 
                    label: `${this.getBankName(ps.code)} ${(ps.kyc_required) ? '(требуется KYC)' : ''}`,
                    min_limit: ps.min_limit,
                    max_limit: ps.max_limit, 
                })
            }
            return formated
        },
        checking() {
            return this.program && this.client && this.client.id && this.order.amount && this.order.description && this.order.description.length >=3
        },
        currentLimits() {
            if(!this.program) return { min: 10, max: 999999999 }
            const paySys = this.paymentSystems.find(ps => ps.code === this.program)
            if(!paySys) return { min: 10, max: 999999999 }
            return {
                min: paySys.min_limit || 10,
                max: paySys.max_limit || 999999999
            }
        },
        clients() {
            if(!this.program || !this.allClients || this.allClients.length === 0) return []
            // Фильтруем клиентов по выбранной программе и статусу KYC
            return this.allClients.filter(c => {
                const paySys = this.paymentSystems.find(ps => ps.code === this.program)
                if(!paySys) return false

                if(paySys.kyc_required !== true){
                    // Если KYC не требуется, возвращаем всех клиентов
                    return true
                }
                
                // Если KYC требуется, возвращаем только подтвержденных клиентов
                if(this.program.code == 'aquaman'){
                    return c.kyc && c.kyc.status === 'approved' && c.kyc.type === 'beorg'
                } else {
                    // Для программы easy_pay нужны клиенты с типом kyc 'easy_pay' и статусом 'approved'
                    return c.kyc && c.kyc.type === 'avangard' && c.kyc.status === 'approved'
                }
            })
        }
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        getSeverity(option) {
            if(!option.kyc || !option.kyc.status) return 'secondary'
            return this.helper.getStatusSeverity(option.kyc.status)
        },
        getStatusTitle(option) {
            if(!option.kyc || !option.kyc.status) return 'Не проверен'
            return this.helper.getStatusTitle(option.kyc.status)
        },
        getBankName(code){
            return this.helper.getBankNameByCode(code)
        },
        showDialog(){
            this.dialog = true
            this.GetPersonalClients()
        },
        async GetPersonalClients() {
            this.loading = true
            const account_data = await this.connect.GetPersonalClients(100, 0).then(res=>res)
            if(account_data.result) {
                // Получим только подтвержденных клиентов
                this.allClients = account_data.data
            } else {
                this.showMess('error', 'Ошибка', 'Ошибка при получении списка клиентов')
                this.allClients = []
            }
            this.loading = false
        },
        async AddOrder(){
            this.loading = true
            if(!this.client || !this.client.id){
                this.showMess('error', 'Ошибка', 'Выберите клиента')
                this.loading = false
                return
            }
            if(!this.order.amount || this.order.amount < this.currentLimits.min || this.order.amount > this.currentLimits.max){
                this.showMess('error', 'Ошибка', `Введите сумму от ${this.currentLimits.min.toLocaleString('ru-RU')} ₽ до ${this.currentLimits.max.toLocaleString('ru-RU')} ₽`)
                this.loading = false
                return
            }
            if(!this.order.description || this.order.description.length < 3){
                this.showMess('error', 'Ошибка', 'Введите описание (минимум 3 символа)')
                this.loading = false
                return
            }

            this.order.client_id = this.client.id
            this.order.payment_system_code = (this.program) ? this.program.code : null

            try{
                const add = await this.connect.AddPersonalOrder(this.order).then(res=>res)
                if(add.result && add.data){
                    this.showMess('success', 'Успешно', 'Счет добавлен')
                    this.dialog = false
                    this.$emit('added', add.data)
                } else {
                    if(add.message){
                        this.showMess('error', 'Ошибка', add.message)
                    } else {
                        this.showMess('error', 'Ошибка', 'Ошибка при добавлении счета')
                    }
                } 
            } catch(e){
                this.showMess('error', 'Ошибка', 'Ошибка при добавлении счета')
                console.log('error', e)
            }  
            this.loading = false
        }
    },
    async mounted() {
        
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>